"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _size2 = _interopRequireDefault(require("lodash/size"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Return true is field value is less then min length.
 * @param {String} field
 * @param {Number} minLength
 * @returns {boolean}
 */
function isValidMinLength(field, minLength) {
  return !(0, _isEmpty2["default"])(field) && (0, _size2["default"])(field) < minLength;
}
var _default = exports["default"] = isValidMinLength;